import React from 'react';
import { Loader2, Wifi, WifiOff } from 'lucide-react';

/** Pill de estado de conexión WAHA, compartido por las páginas de mensajes. */
interface WahaStatusBadgeProps {
  connected: boolean | null;
  checking: boolean;
}

const WahaStatusBadge: React.FC<WahaStatusBadgeProps> = ({ connected, checking }) => (
  <div
    className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium ${
      checking
        ? 'bg-canvas text-content-2'
        : connected
          ? 'bg-green-100 dark:bg-green-500/20 text-green-800 dark:text-green-300'
          : 'bg-red-100 dark:bg-red-500/20 text-red-800 dark:text-red-300'
    }`}
  >
    {checking ? (
      <Loader2 className="h-3 w-3 mr-1.5 animate-spin" />
    ) : connected ? (
      <Wifi className="h-3 w-3 mr-1.5" />
    ) : (
      <WifiOff className="h-3 w-3 mr-1.5" />
    )}
    {checking ? 'Verificando...' : connected ? 'WhatsApp conectado' : 'WhatsApp desconectado'}
  </div>
);

export default WahaStatusBadge;
